import { useMutation, useQueryClient } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteFiles = ({ caseId, matterId }: { caseId: string; matterId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (fileIds: string[]) => {
      const data = {
        fileIds: fileIds,
        caseId,
      };
      const fetchConfig = getFetchConfig({ method: FetchMethod.DELETE, data });

      await fetch(`${APIBaseChronos}/api/matter/${matterId}/files`, fetchConfig);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries([QueryEntity.Files, { matterId }]);
      },
    },
  );
};
